const mlJSON = {
  Blueprints: 'ബ്ലൂപ്രിന്റുകൾ',
  'Extended Sidebar': 'വിപുലീകരിച്ച സൈഡ്ബാർ',
  'Accent Sidebar': 'അക്സന്റ് സൈഡ്ബാർ',
  'Accent Header': 'അക്സന്റ് ഹെഡർ',
  'Boxed Sidebar': 'ബോക്സ്ഡ് സൈഡ്ബാർ',
  'Collapsed Sidebar': 'ചുരുക്കിയ സൈഡ്ബാർ',
  'Bottom Navigation': 'താഴെയുള്ള നാവിഗേഷൻ',
  'Top Navigation': 'മുകളിലെ നാവിഗേഷൻ',
  'Lead Developer': 'ലീഡ് ഡെവലപ്പർ',
  'Mega menu': 'മെഗാ മെനു',
  Doctors: 'ഡോക്ടർമാർ',
  Reports: 'റിപ്പോർട്ടുകൾ',
  Hospital: 'ആശുപത്രി',
  Export: 'കയറ്റുമതി',
  'Last year': 'കഴിഞ്ഞ വർഷം',
  Expenses: 'ചെലവുകൾ',
  Products: 'ഉൽപ്പന്നങ്ങൾ',
  Statistics: 'സ്ഥിതിവിവരക്കണക്കുകൾ',
  General: 'പൊതുവായത്',
  Automation: 'ഓട്ടോമേഷൻ',
  'Data Display': 'ഡാറ്റ ഡിസ്പ്ലേ',
  Calendar: 'കലണ്ടർ',
  Mailbox: 'മെയിൽബോക്സ്',
  Dashboards: 'ഡാഷ്‌ബോർഡുകൾ',
  Analytics: 'അനലിറ്റിക്സ്',
  Banking: 'ബാങ്കിംഗ്',
  Commerce: 'കൊമേഴ്‌സ്',
  Crypto: 'ക്രിപ്റ്റോ',
  Finance: 'ധനകാര്യം',
  Fitness: 'ഫിറ്റ്നസ്',
  Healthcare: 'ആരോഗ്യ സംരക്ഷണം',
  Helpdesk: 'ഹെൽപ്പ്ഡെസ്ക്',
  Learning: 'പഠനം',
  Monitoring: 'മേൽനോട്ടം',
  Tasks: 'ചുമതലകൾ',
  Applications: 'അപ്ലിക്കേഷനുകൾ',
  'File Manager': 'ഫയൽ മാനേജർ',
  'Jobs Platform': 'ജോബ്സ് പ്ലാറ്റ്ഫോം',
  Messenger: 'മെസ്സഞ്ചർ',
  'Projects Board': 'പ്രോജക്ട് ബോർഡ്',
  Management: 'മാനേജ്മെന്റ്',
  Users: 'ഉപയോക്താക്കൾ',
  'List All': 'എല്ലാം കാണിക്കുക',
  'User Profile': 'ഉപയോക്തൃ വിവരങ്ങൾ',
  Projects: 'പ്രോജക്ടുകൾ',
  Shop: 'ഷോപ്പ്',
  Invoices: 'ഇൻവോയ്സുകൾ',
  Login: 'ലോഗിൻ',
  Register: 'രജിസ്റ്റർ ചെയ്യുക',
  Status: 'സ്റ്റാറ്റസ്',
  Settings: 'ക്രമീകരണങ്ങൾ',
  'Language Switcher': 'ഭാഷ മാറ്റുക',
  'Sign out': 'ലോഗ് ഔട്ട്'
};

export default mlJSON;
